export class UserAuditDetail{
    public AuditID:number = 1;
    public AuditName:string = "";
    public AuditTypeID:number = 1;
    public AuditType:string = "";
    public HasPermission:boolean = false;
    constructor(values: Object = {}) {        
        Object.assign(this, values);       
    }
}